// extracted by mini-css-extract-plugin
export var aiStarIcon = "_li-2";
export var container = "_li-4";
export var dismissButton = "_li-3";
export var hasPaddingBottom = "_li-6";
export var last = "_li-e";
export var scrollbarThumb = "_li-c";
export var scrollbarTrack = "_li-b";
export var selected = "_li-9";
export var spin = "_li-1";
export var spinning = "_li-0";
export var suggestionItem = "_li-d";
export var suggestionsPanel = "_li-5";
export var tonePill = "_li-8";
export var tonesContainer = "_li-7";
export var unselected = "_li-a";